import { Component, Injector, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { BaseEntityComponent, BaseEntityConfig, BnLoadingService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { ROLE_AGENTE_CONSULTA, ROLE_AGENTE_ENVIO, ROLE_GESTOR_CONSULTA, ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { AgenteFinanceiro } from "src/app/model/agente-financeiro.model";
import { SolicitacaoDevolucaoHonra } from "src/app/model/devolucao-honra.model";
import Utils from 'src/app/shared/fgi-utils';
import { OcorrenciaValidacaoVO } from "src/app/shared/ocorrencia-validacao.vo";
import { PermissaoService } from 'src/app/shared/permissao.service';
import { SolicitacaoDevolucaoHonraService } from "../devolucao-honra.service";
import { TipoEstorno, TipoEstornoEnum } from "src/app/model/tipo-estorno-enum";


@Component({
    templateUrl: './devolucao-detalhe.component.html',
    styleUrls: ['./devolucao-detalhe.component.scss'],
    standalone: false
})
export class DevolucaoHonraDetalhesComponent extends BaseEntityComponent<SolicitacaoDevolucaoHonra> implements OnInit {

    private agentesFinanceiros: AgenteFinanceiro[] = [];
    public solicitacaoDevolucao: SolicitacaoDevolucaoHonra;
    public permissaoLinkN03: false;
    public podeCancelar = false;
    public ocorrencias: OcorrenciaValidacaoVO[] = [];
    public podeDevolver = false;
    public ehAgente: boolean = false;
    public podeLancarEstorno = false;
    public estornoManual: TipoEstornoEnum;
    tiposEstorno: TipoEstorno[] = [
        {
          nome: 'Não',
          valor: TipoEstornoEnum.NAO,
        },
        {
          nome: 'Parcial',
          valor: TipoEstornoEnum.PARCIAL,
        },
        {
          nome: 'Total',
          valor: TipoEstornoEnum.TOTAL,
        },
      ];

    @ViewChild('cancelamento') mensagemCancelamento: TemplateRef<any>;
    @ViewChild('botoesDeAcao') botoesDeAcao: TemplateRef<any>;

    @ViewChild('confirmEstorno') confirmEstorno: TemplateRef<any>;
    @ViewChild('confirmEstornoBotoes') confirmEstornoBotoes: TemplateRef<any>;

    constructor(protected injector: Injector,
        private devolucaoService: SolicitacaoDevolucaoHonraService,
        private permissaoService: PermissaoService,
        private modalService: BnModalMessageService,
        private loadingService: BnLoadingService,
        private activatedRoute: ActivatedRoute,
    ) {

        super(devolucaoService, new BaseEntityConfig('/devolucao'));
        this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'];
        this.config.rotaLista = '/devolucao/pesquisa';
    }

    ngOnInit() {
        
        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
            
            this.permissaoLinkN03 = resp && (resp[ROLE_GESTOR_CONSULTA] || resp[ROLE_GESTOR_ENVIO]);
            this.podeCancelar =  resp && (resp[ROLE_AGENTE_ENVIO] || resp[ROLE_GESTOR_ENVIO]);
            this.podeDevolver = resp && (resp[ROLE_AGENTE_ENVIO] || resp[ROLE_GESTOR_ENVIO]);
            this.ehAgente = resp && (resp[ROLE_AGENTE_ENVIO || resp[ROLE_AGENTE_CONSULTA]]);
            this.podeLancarEstorno = resp && (resp[ROLE_GESTOR_ENVIO]);
        });

        this.route.params.subscribe(params => {
            this.devolucaoService.getSolicitacaoDevolucao(params['id']).subscribe(resp => {
                this.solicitacaoDevolucao = resp;
                this.estornoManual = TipoEstornoEnum[this.solicitacaoDevolucao.estornoManual];
            });
        });
    }

    abrirModalConfirmacao(aprovar: boolean) {

        const tituloReprovacao = 'Cancelamento da devolução de honra';

        this.modalService
            .abrir(tituloReprovacao, null, 'lg',
                this.mensagemCancelamento,
                this.botoesDeAcao)
            .result
            .then((solicitacaoDevolucaoCancelada: SolicitacaoDevolucaoHonra) => {
                this.solicitacaoDevolucao = solicitacaoDevolucaoCancelada;

                this.messageService.addMessage({
                    title: 'Sucesso',
                    type: 'CRUD_OPERATION',
                    level: messageLevel.SUCCESS,
                    message: 'Solicitação de devolução de honra cancelada com sucesso.'
                });
                this.ocorrencias = [];
            }, (reason) => {
                console.log(reason);
            });
    }
    voltarParaLista() {
        this.router.navigate(['/devolucao']);
    }

    confirmarCancelamento() {
        this.loadingService.bloqueiaTela();
        this.devolucaoService
            .cancelarSolicitacaoDevolucao(this.solicitacaoDevolucao.id)
            .subscribe(solicitacaoCancelamento => {
                this.modalService.close(solicitacaoCancelamento);
                this.loadingService.liberaTela();
            }, error => {
                console.log(error);
                this.ocorrencias = this.devolucaoService.ocorrencias;
                this.loadingService.liberaTela();
            });
    }

    desistirDoCancelamento() {
        this.modalService.dismiss('abortou cancelamento');
    }

    nomeAgente(cnpj: string) {
        return Utils.nomeAgentePorCNPJ(cnpj, this.agentesFinanceiros);
    }

    habilitadoCancelar(): boolean{
        return this.podeCancelar && ["1", "2"].indexOf(<any>this.solicitacaoDevolucao.estado.id) !== -1;
    }

    atualizaEstornoManual() {
        this.devolucaoService.atualizarEstorno(this.solicitacaoDevolucao.id, this.estornoManual).subscribe(resp => {
            this.devolucaoService.getSolicitacaoDevolucao(this.solicitacaoDevolucao.id).subscribe(resp => {
                this.solicitacaoDevolucao = resp;
                this.estornoManual = TipoEstornoEnum[this.solicitacaoDevolucao.estornoManual];
            });
          this.modalService.dismiss();
        });
      }
  
    cancelarEstorno() {
      this.estornoManual = TipoEstornoEnum[this.solicitacaoDevolucao.estornoManual];
      this.modalService.dismiss();
    }
  
    abrirModalConfirmarAlteracaoEstorno() {
      this.modalService.abrir('Confirmação', null, 'lg', this.confirmEstorno, this.confirmEstornoBotoes);
    }
}
